import { Component, OnInit } from '@angular/core';
import { PageHeaderCommands, Dismissable } from '../page-header.commands';
import { TeacherProvider } from 'src/app/providers/teacher/teacher.provider';
import { Teacher } from 'src/app/models/teacher';
import { Page } from 'src/app/models/page';
import { MenuController } from '@ionic/angular';
import { Common } from 'src/app/lib/common';
import { Router } from '@angular/router';
import { TeacherStore } from 'src/app/stores/teacher.store';
import { Subject, map, takeUntil } from 'rxjs';

@Component({
  selector: 'app-responsive-menu',
  templateUrl: './responsive-menu.component.html',
  styleUrls: ['./responsive-menu.component.scss']
})
export class ResponsiveMenuComponent implements OnInit, Dismissable {

  teacher: Teacher
  ngUnsubscribeTeacher = new Subject();

  // TODO set these
  isLessonPlans: boolean = false
  isVideoLibrary: boolean = false
  isPemLibrary: boolean = false
  isTeacherNotes: boolean = false
  isTeachingTools: boolean = false
  isTrainings: boolean = false
  isPages: boolean = false
  isResourceExpanded: boolean = false;
  constructor(public commands: PageHeaderCommands,
    private teacherProvider: TeacherProvider,
    private menuCtrl: MenuController,
    private teacherStore: TeacherStore,
    private router: Router) {

      this.teacher = this.teacherProvider.teacher;
      this.teacherStore.state$
          .pipe(takeUntil(this.ngUnsubscribeTeacher))
          .subscribe(() => {
            this.teacher = this.teacherProvider.teacher;
          });
  }

  ngOnInit() {
  }

  ngOnDestroy(){
    this.ngUnsubscribeTeacher.next(true);
    this.ngUnsubscribeTeacher.complete();
  }

  dismiss() {
    const menu = Common.menu('responsive-menu')
    menu.close()
  }

  isCurrentPage(url: string): boolean {
    const currentUrl = this.router.url.slice(7)
    return currentUrl === url
  }

  isCurrentBlog(url: string): boolean {
    const currentUrl = this.router.url.slice(7)
    return currentUrl === url
  }

  isChildPage(page: Page): boolean {
    return page.parentId > 0
  }

  resourcePages(): Page[] {
    const resourcePages = new Array<Page>()
    this.teacher.resourcePages.forEach( (page: Page) => {
      if (0 === page.parentId) {
        resourcePages.push(page)
      }
    })
    return resourcePages
  }

  public trackByUuid(index: number, page: Page) {
    return page.uuid;
  }

  onResourceExpansion(){
    this.isResourceExpanded = !this.isResourceExpanded;
  }

}
